import { t } from "@/i18n/translate";
import type { AccountUpdateRequest, CreateFirstAdminRequest, CreateUserRequest } from "@/types/generated/openapi";

export type UserValidationErrors = {
  fullname?: string;
  password?: string;
  username?: string;
  password_repeat?: string;
};

export function validateUpdateUser(
  accountUpdate: Required<AccountUpdateRequest>,
  passwordRepeat: string,
): UserValidationErrors {
  const errors: UserValidationErrors = {};

  if (accountUpdate.fullname.length === 0) {
    errors.fullname = t("form_errors.FORM_VALIDATION_RESULT_REQUIRED");
  }

  if (accountUpdate.password.length === 0) {
    errors.password = t("account.password_length_rule");
  }

  if (accountUpdate.password !== passwordRepeat) {
    errors.password_repeat = t("account.password_mismatch");
  }

  return errors;
}

export function validateCreateUser(
  accountCreate: CreateUserRequest | CreateFirstAdminRequest,
  passwordRepeat: string | undefined,
): UserValidationErrors {
  const errors: UserValidationErrors = {};

  if (accountCreate.fullname?.length === 0) {
    errors.fullname = t("form_errors.FORM_VALIDATION_RESULT_REQUIRED");
  }

  if (accountCreate.username.length === 0) {
    errors.username = t("form_errors.FORM_VALIDATION_RESULT_REQUIRED");
  }

  if (accountCreate.temp_password.length === 0) {
    errors.password = t("account.password_length_rule");
  }

  if (passwordRepeat !== undefined && accountCreate.temp_password !== passwordRepeat) {
    errors.password_repeat = t("account.password_mismatch");
  }

  return errors;
}
